import React from "react";
import { Link } from "react-router-dom";

import { AboutUsIcon, ContactUsIcon } from "../../assets/Icons";

const Header = ({ openSidebar, setOpenSidebar }) => {
  return (
    <div className="header-camp flex z-50 top-0 left-0 right-0 w-full py-4 px-0 bg-black/90">
      <div className="wrapWidth wrap flex items-center">
        <div className="left flex items-center">
          <Link to="/" className="logo-img flex items-center justify-center">
            <img
              src="../images/logo.svg"
              className="logo sm:w-[160px] w-[100px]"
            />
          </Link>
        </div>
        <div className="right flex items-center justify-end">
          <div className="flex items-center sm:gap-6 gap-2">
            <Link
              to="/about-us"
              // target="_blank"
              className="flex items-center justify-center gap-2 cursor-pointer"
            >
              <div className="flex items-center justify-center h-5 w-5">
                <AboutUsIcon />
              </div>
              <h3 className="text-white font-light text-sm">About Us</h3>
            </Link>
            <a
              href="/"
              target="_blank"
              className="flex items-center justify-center gap-2 cursor-pointer"
            >
              <div className="flex items-center justify-center h-5 w-5">
                <ContactUsIcon />
              </div>
              <h3 className="text-white font-light text-sm">Contact Us</h3>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
